
import TeampulseLogo from '~/components/atoms/TeampulseLogo.vue'

export default {
  components: { TeampulseLogo },
}
